import { render } from "./FormResetPassword.vue?vue&type=template&id=641d18b7&scoped=true&ts=true"
import script from "./FormResetPassword.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormResetPassword.vue?vue&type=script&lang=ts&setup=true"

import "./FormResetPassword.vue?vue&type=style&index=0&id=641d18b7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641d18b7"],['__file',"src/pages/login/components/FormResetPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "641d18b7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('641d18b7', __exports__)) {
    api.reload('641d18b7', __exports__)
  }
  
  module.hot.accept("./FormResetPassword.vue?vue&type=template&id=641d18b7&scoped=true&ts=true", () => {
    api.rerender('641d18b7', render)
  })

}


export default __exports__